import React from "react";
import IntroContent from "./introContent";
import PreviousScreen from "./img/previous-desktop.png";
import PreviousScreenMobile from "./img/previous-mobile.png";
import IconFaAngleDL from "../img/IconFaAngleDL";
import IconFaAngleDR from "../img/IconFaAngleDR";

function IntroSection() {
	return (
		<>
			<section className="content-block" id={IntroContent.meta}>
				<h4 className="block-title">My role:</h4>
				<ul className="skills-list">
					{IntroContent.role.map((li) => {
						return <li className="skill-tag">{li}</li>;
					})}
				</ul>
				<h4 className="section-title-meta"> {IntroContent.meta} </h4>
				<h3 className="section-title"> {IntroContent.title} </h3>
				{IntroContent.paras.map((p) => {
					return <p>{p}</p>;
				})}
			</section>
			<section className="figure-block previous-screens">
				<span className="inner">
					<ol className="captions-list">
						{IntroContent.captions.map((li) => {
							return <li className="caption">{li}</li>;
						})}
					</ol>
					<figure className="screen desktop">
						<i data-dot="1"></i>
						<i data-dot="2"></i>
						<i data-dot="3"></i>
						<i data-dot="4"></i>
						<i data-dot="5"></i>
						<img src={PreviousScreen} alt={IntroContent.img01alt} />
					</figure>
					<figure className="screen mobile">
						<i data-dot="6"></i>
						<img src={PreviousScreenMobile} alt={IntroContent.img02alt} />
					</figure>
				</span>
			</section>
			<blockquote className="quote">
				<IconFaAngleDL />
				<span className="statement">{IntroContent.quote.statement}</span>
				<span className="personna">{IntroContent.quote.personna}</span>
				<IconFaAngleDR />
			</blockquote>
		</>
	);
}

export default IntroSection;
